import Hero     from './Hero';
import Services from './Services';
import Gallery  from './Gallery';
import About    from './About';
import Faq      from './Faq';
import Cta      from './Cta';

export default function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <Gallery />
      <About />
      <Faq />
      <Cta />
    </main>
  );
}
